import { render, staticRenderFns } from "./GraficoBarComparativo.vue?vue&type=template&id=a34d2478"
import script from "./GraficoBarComparativo.vue?vue&type=script&lang=js"
export * from "./GraficoBarComparativo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports